import {SET_APP_CONTEXT} from '../constants';
import {SetAppContextAction} from '../index';
import {City} from './City';

export function citiesReducer(state: City[] = [], action: SetAppContextAction): City[] {
  switch (action.type) {
    case SET_APP_CONTEXT:
      return action.payload.cities;
    default:
      return state;
  }
}
